import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaEnvelope, FaFutbol, FaArrowLeft } from 'react-icons/fa';
import toast from 'react-hot-toast';
import Button from '../components/UI/Button';
import api from '../api/axios';

function ForgotPassword() {
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent]       = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) { toast.error('Saisis ton email'); return; }

    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch {
      toast.error('Erreur serveur, réessaie plus tard');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="app-container flex flex-col min-h-screen"
      style={{ background: 'radial-gradient(ellipse at top, #1a4a2e 0%, #0d2b1a 70%)' }}
    >
      {/* Header */}
      <div
        className="flex-shrink-0 h-40 flex flex-col items-center justify-end pb-5"
        style={{ background: 'radial-gradient(ellipse at 50% 0%, rgba(240,180,41,0.15) 0%, transparent 70%)' }}
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', stiffness: 200, damping: 20 }}
          className="w-16 h-16 rounded-full bg-qfl-card border-2 border-qfl-gold flex items-center justify-center mb-2"
          style={{ boxShadow: '0 0 20px rgba(240,180,41,0.3)' }}
        >
          <FaFutbol size={28} className="text-qfl-gold" />
        </motion.div>
        <h1
          className="text-2xl font-black uppercase tracking-widest"
          style={{ fontFamily: "'Rajdhani', sans-serif", color: '#f0b429' }}
        >
          OM QUIZ
        </h1>
      </div>

      {/* Corps */}
      <motion.div
        className="flex-1 flex flex-col justify-center px-6 py-8"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        {sent ? (
          <div className="text-center">
            <div className="text-5xl mb-4">📧</div>
            <h2
              className="text-xl font-bold text-qfl-gold mb-3"
              style={{ fontFamily: "'Rajdhani', sans-serif" }}
            >
              EMAIL ENVOYÉ !
            </h2>
            <p className="text-white/60 text-sm leading-relaxed mb-6">
              Si cet email correspond à un compte, tu recevras un lien de réinitialisation dans quelques minutes.
              Vérifie aussi tes spams.
            </p>
            <Link
              to="/login"
              className="text-qfl-gold font-bold hover:text-yellow-400 transition-colors"
            >
              ← Retour à la connexion
            </Link>
          </div>
        ) : (
          <>
            <h2
              className="text-xl font-bold text-white mb-2 text-center"
              style={{ fontFamily: "'Rajdhani', sans-serif" }}
            >
              MOT DE PASSE OUBLIÉ
            </h2>
            <p className="text-white/50 text-sm text-center mb-6">
              Saisis ton email pour recevoir un lien de réinitialisation.
            </p>

            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <div className="relative">
                <FaEnvelope size={14} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
                <input
                  type="email"
                  placeholder="Ton email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-input pl-11"
                  autoComplete="email"
                />
              </div>

              <Button type="submit" variant="gold" size="lg" fullWidth loading={loading} className="mt-1">
                ENVOYER LE LIEN
              </Button>
            </form>

            <p className="text-center text-white/50 text-sm mt-6">
              <Link to="/login" className="text-qfl-gold font-bold hover:text-yellow-400 transition-colors flex items-center justify-center gap-2">
                <FaArrowLeft size={12} /> Retour à la connexion
              </Link>
            </p>
          </>
        )}
      </motion.div>
    </div>
  );
}

export default ForgotPassword;
